import { writeBatch } from "firebase/firestore";
import { db } from "../../firebase";

const DEFAULT_BATCH_SIZE = 400;

export const commitBatchedWrites = async ({
  operations = [],
  batchSize = DEFAULT_BATCH_SIZE,
} = {}) => {
  for (let offset = 0; offset < operations.length; offset += batchSize) {
    const batch = writeBatch(db);
    const chunk = operations.slice(offset, offset + batchSize);

    chunk.forEach((operation) => operation(batch));
    await batch.commit();
  }
};
